interface ISiteElementFavoritesResponse
{
    items: number;
}

class SiteElementFavorites
    extends QueryElement<HTMLElement> {
    
    private readonly _site: Site;

    private readonly _number: IQueryElement;
    
    constructor(element: HTMLElement, site: Site) {
        super(element);

        this._site = site;

        let number = this.query(".number").first<IQueryElement>();


        if (number == null)
            throw "Element(s) not found!";

        this._number = number;
        this.reload();
    }

    async reload() {
        let request = new QueryRequest('/Favorites/Get', {
            contentType: 'json',
            method: 'get'
        });

        let response = await request.request();
        let jsonResponse: ISiteElementFavoritesResponse = await response.json();

        this._number.setHtml(jsonResponse.items.toString());

        if (this._site instanceof SiteAssortment) {
            await this._site.reloadFilters();
        }
    }
}